import React from 'react';
import { SidebarProvider } from '../../contexts/SidebarContext';
import AdminSidebar from './AdminSidebar';

const AdminLayout = ({ children }) => {
  return (
    <SidebarProvider>
      <div className="flex min-h-screen bg-gray-50 dark:bg-gray-950">
        <AdminSidebar />
        {children}
      </div>
    </SidebarProvider>
  );
};

export default AdminLayout;
